<template>
    <ul>
        <router-link
                v-for="(step, stepKey, stepIndex) in steps"
                :key="step.id"
                :to="path(step.id)"
                :style="cssStyle(stepIndex)"
                :class="cssClass(stepKey)">
            <span>{{step.label}}</span>
        </router-link>
    </ul>
</template>

<script>
    import stepDependenciesAreMet from "../lib/stepDependenciesAreMet";

    export default {
        name: 'ConstructorNav',

        computed: {
            answers() {
                return this.$store.state.answers;
            },

            steps() {
                return this.$store.state.steps;
            },

            currentStep() {
                return this.$route.params.step;
            },
            isBackCapLocked(){
                return this.$store.state.lockBackCap
            },
            isRecap(){
                return parseInt(this.$route.params.step) === Object.keys(this.$store.state.steps).length
            }
        },

        methods: {
            cssClass(stepKey) {
                stepKey = parseInt(stepKey)
                return {
                    'done': stepKey < this.currentStep,
                    'todo': stepKey > this.currentStep,
                    'selected': stepKey === parseInt(this.currentStep),
                    'prev': stepKey === parseInt(this.currentStep) - 1,
                    'prev-2': stepKey === parseInt(this.currentStep) - 2,
                    'come': stepKey === parseInt(this.currentStep) + 1,
                    'come-2': stepKey === parseInt(this.currentStep) + 2,
                    'hidden': !stepDependenciesAreMet(this.steps[stepKey], this.answers),
                    'locked' : this.isBackCapLocked || this.isRecap,
                    'first' : stepKey === 1
                };
            },

            cssStyle(stepIndex) {
                return {'z-index': 20 - stepIndex};
            },

            path(stepId) {
                return {path: 'etape' + stepId};
            }
        }
    }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    .locked,
    .locked *{
        pointer-events: none;
    }


    ul {
        display: flex;
        justify-content: space-around;
        align-items: center;
        flex-grow: 1;
        height: 50px;
        margin: 0;
        padding: 0;
        list-style: none;
        border-bottom: solid 1px lightgray;
        overflow: hidden;
    }

    a {
        position: relative;
        width: 100%;
        text-decoration: none;
        padding: 15px 0 15px 40px;
        text-align: center;
        font-weight: 600;
        letter-spacing: 0.04rem;
    }

    a:first-child {
        padding: 15px 0 15px 0px;
    }

    a.todo {
        color: #fff;
        background: #c5c5c5;
        pointer-events: none;
    }

    a.done {
        background: #2d2d2d;
        color: #fff;
        z-index: 3;
    }

    a.selected {
        color: #2d2d2d;
        z-index: 3;
    }
    a.selected::after{
    }
    a.todo::after,
    a.selected::after,
    a.done::after {
        content: "";
        position: absolute;
        background: #fff;
        transform: translateY(-50%) rotateZ(45deg);
        top: 50%;
        right: -20px;
        height: 50px;
        width: 50px;
        border-top: 1px solid #fff;
        border-right: 1px solid #fff;
        transition: 0.4s all linear;
        z-index: -1;
    }

    a.todo::after {
        background: #c5c5c5;
        pointer-events: none;
    }

    a.done::after {
        background: #2d2d2d;
    }

    a.selected::after {
    }

    a.selected::after,
    a.done::after,
    a.done,
    a.selected,
    a.todo {
        transition: all 0.4s linear;
    }

    a.hidden {
        display: none!important;
    }

    a > span {
        z-index: 1000;
        font-size: 0.8rem;
    }

    @media screen and (max-width: 1199px) {
        a:first-child {
            padding: 25px 0 25px 0;
        }
    }

    @media screen and (max-width: 1023px) {
        a {
            display: none;
        }

        a.selected, a.prev, a.come, a.prev-2, a.come-2 {
            display: block;
        }

        a.todo::after,
        a.selected::after,
        a.done::after {
            top: 50%;
            right: -25px;
            height: 70px;
            width: 70px;
        }

        a {
            padding: 35px 20px 35px 50px
        }

        ul {
            height: 60px;
        }
    }

    @media screen and (max-width: 767px) {
        a.prev-2, a.come-2 {
            display: none;
        }

        a {
            padding: 15px 10px 15px 30px;
        }

        a.todo::after,
        a.selected::after,
        a.done::after {
            top: 50%;
            right: -10px;
            height: 70px;
            width: 70px;
        }

        ul {
            height: 50px;
        }
    }

    @media screen and (max-width: 575px) {

        a {
            padding: 17px 10px 17px 30px;
        }
        a:first-child {
            width: 90%;
            margin-right: auto;
        }
    }

</style>
